import { Link } from 'react-router-dom';

export default function NaoEncontradaPage() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background-100 px-4 py-8">
      <div className="w-full max-w-[420px] overflow-hidden rounded-lg border border-secondary-200 bg-white">
        <div className="h-[10px] w-full bg-primary-500" />
        <div className="p-6 text-center">
          <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-secondary-100 text-secondary-700">
            <i className="ri-error-warning-line text-2xl" />
          </span>
          <h1 className="mt-4 text-xl font-medium text-foreground-950">Página não encontrada</h1>
          <p className="mt-2 text-sm text-foreground-600">
            O endereço pode estar incorreto ou a página não existe mais.
          </p>

          <div className="mt-6 space-y-3">
            <Link
              to="/"
              className="flex w-full cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-white transition-colors hover:bg-primary-600"
            >
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-calendar-2-line" />
              </span>
              Ver eventos
            </Link>
            <Link
              to="/minhas-inscricoes"
              className="flex w-full cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-secondary-300 px-6 py-3 text-sm font-medium text-foreground-800 transition-colors hover:bg-background-100"
            >
              <span className="flex h-4 w-4 items-center justify-center text-primary-600">
                <i className="ri-file-list-3-line" />
              </span>
              Minhas inscrições
            </Link>
            <Link
              to="/meus-ingressos"
              className="flex w-full cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-secondary-300 px-6 py-3 text-sm font-medium text-foreground-800 transition-colors hover:bg-background-100"
            >
              <span className="flex h-4 w-4 items-center justify-center text-primary-600">
                <i className="ri-ticket-2-line" />
              </span>
              Meus ingressos
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}